import { IDocumentObjectsInformationObject } from "./IDocumentObjectsInformation";
import { DocumentObjectsInformationObjectOption } from "./DocumentObjectsInformationObjectOption";

export class DocumentObjectsInformationObject implements IDocumentObjectsInformationObject {
  type: string;
  typeDetail: string;
  id?: number;
  name?: string;
  subName?: string;
  viewTitle: string;
  itemName?: string;
  groupName?: string;
  value?: string;
  valueFormat?: number;
  text?: string;
  isSelected?: boolean;
  hisItemName?: string;
  isTime?: boolean;
  isEmpty?: boolean;
  dateTimeFormat?: string;
  dateTimeLanguage?: string;
  options?: DocumentObjectsInformationObjectOption[];
}
